<template>
    <div>
        <div class="content-wrapper" v-if="!loadingComplete()">
            <section class="content">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-header">
                            <h3 class="box-title">Chargement en cours</h3>
                        </div>
                        <div class="box-body">
                            Chargement des opérations
                        </div>
                        <div class="overlay">
                            <i class="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="content-wrapper" v-if="loadingComplete()">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                <h1>
                    Liste des opérations bancaires
                    <small></small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li><a href="#">Comptabilité</a></li>
                    <li class="active">Opérations</li>
                </ol>
            </section>
            <section class="content">
                <div id="searchAndVueTable">
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <recherche-operation></recherche-operation>
                        </div>
                    </div>

                    <div class="row">
                        <ventilation>
                        </ventilation>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="box">
                                <div class="box-header">
                                    <h3 class="box-title">Liste des opérations</h3>
                                    <div class="box-tools">
                                        <div style="display:inline-block">
                                            <span style="display:inline-block">Par Page:</span>
                                            <select class="form-control" v-model="perPage"
                                                    style="display:inline-block;width: 100px;">
                                                <option selected="selected" value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="75">75</option>
                                                <option value="100">100</option>
                                            </select>
                                        </div>
                                    </div>
                                </div><!-- /.box-header -->

                                <div class="vuetable-wrapper"
                                     :class="{'loading' : getLoadingTableOperation}"
                                >
                                    <div class="box-body table-responsive no-padding"
                                    >
                                        <vuetable
                                                ref="vuetable"
                                                :api-url="routeOperationIndex"
                                                :css="cssBootstrap"
                                                :fields="vueTableOperation.columns"
                                                :item-actions="vueTableOperation.itemActions"
                                                :per-page="perPage"
                                                :sort-order="vueTableOperation.sortOrder"
                                                :multi-sort="true"
                                                :render-icon="renderIcon"
                                                pagination-component="vuetable-pagination-bootstrap"
                                                wrapper-class="vuetable-wrapper"
                                                detail-row-component="detailrow"
                                                loading-class="loading"
                                                detail-row-id="id"
                                                detail-row-transition="expand"
                                                row-class-callback="rowClassCB"
                                                table-wrapper=".vuetable-wrapper"
                                                :append-params="getSearchRequest"
                                                @vuetable:pagination-data="onPaginationData"
                                                @vuetable:cell-clicked="onCellClicked"
                                                @vuetable:loading="loading"
                                                @vuetable:loaded="loaded"
                                        >
                                            <template slot="compte_de" slot-scope="props">
                                                <router-link
                                                        :to="{ name: 'Compte', params: { id_compte: props.rowData.compte_de.proprietaire.id }}">
                                                    {{props.rowData.compte_de.proprietaire.nom}}
                                                </router-link>
                                            </template>
                                            <template slot="compte_vers" slot-scope="props">
                                                <router-link
                                                        :to="{ name: 'Compte', params: { id_compte: props.rowData.compte_vers.proprietaire.id }}">
                                                    {{props.rowData.compte_vers.proprietaire.nom}}
                                                </router-link>
                                            </template>
                                            <template slot="actions" slot-scope="props">
                                                <div class="custom-actions">
                                                    <button class="btn btn-default padding2"
                                                            @click="toggleDetailRow(props.rowData)">
                                                        <i class="glyphicon glyphicon-zoom-in"></i>
                                                    </button>
                                                    <button class="btn btn-warning padding2"
                                                            @click="ventilerItem(props.rowData)">
                                                        <i class="glyphicon glyphicon-random"></i>
                                                    </button>
                                                    <button class="btn btn-primary padding2"
                                                            v-if="dontShowIfVentille(props.rowData)"
                                                            @click="setInCompteAttente(props.rowData)">
                                                        <i class="glyphicon glyphicon-flash"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </vuetable>
                                        <vuetable-pagination
                                                ref="pagination"
                                                @vuetable-pagination:change-page="onChangePage"
                                        ></vuetable-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script type="text/babel">
    import Vue from 'vue'
    import vuetable from '../VueTable/Lib/Vuetable.vue'
    import VuetablePagination from '../VueTable/Lib/VuetablePagination.vue'
    import RechercheOperation from '../Recherches/RechercheOperation.vue'
    import ventilation from '../Operations/ventilation.vue'
    import {mapGetters, mapActions} from 'vuex'
    import BootstrapStyle from '../Communs/cssBootstrap-css'
    import detailrow from '../VueTable/Templates/RowDetailsOperations.vue'
    import vueTableOperation from '../VueTable/configs/vueTableOperation'

    var moment = require('moment');
    var _ = require('underscore')

    Vue.component('detailrow', detailrow)

    export default {
        props: {},
        data() {
            return {
                resultsSearch: {},
                visibleDetailRows: [],
                cssBootstrap: BootstrapStyle,
                perPage: 25,
                vueTableOperation: vueTableOperation,
                routeOperationIndex: ""
            }
        },
        components: {
            RechercheOperation,
            vuetable,
            VuetablePagination,
            ventilation
        },
        methods: {
            ...mapActions({
                majOperationSelected: "majOperationSelected",
                submitToProcess: "submitToProcess",
                majLoadingTableOperation: "majLoadingTableOperation",
                addVentilationFromOperationSelected: 'addVentilationFromOperationSelected',
                setRubriquesSorties: 'setRubriquesSorties',
                setRubriquesEntrees: 'setRubriquesEntrees',
                majOperationInSearchResults: 'majOperationInSearchResults'
            }),
            loadRubriquesEntreesSorties: function () {
                this.$http.get(this.getRoute('Comptabilite.getRubriquesEntreesSorties'))
                    .then((response) => {
                        this.setRubriquesEntrees(response.body['rubriquesEntrees'])
                        this.setRubriquesSorties(response.body['rubriquesSorties'])
                    }, (response) => {
                        this.setRubriquesEntrees(null)
                        this.setRubriquesSorties(null)
                    });
            },
            loadResultsOfSearch: function () {
                this.$http.post(this.getRoute('operationsIndexPost'), this.getAllQueryParams()).then((response) => {

                    this.loadSuccess(response);
                }, (response) => {
                    this.loadFailed(response);
                });
            },
            loadingComplete: function () {
                return true
            },
            loading: function () {
                this.majLoadingTableOperation(true)
            },
            loaded: function () {
                this.majLoadingTableOperation(false)
            },
            renderIcon(classes, options) {
                return `<span class="${classes.join(' ')}"></span>`
            },
            onCellClicked(data, field, event) {
                this.$refs.vuetable.toggleDetailRow(data.id)
            },
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
            },
            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },
            toggleDetailRow: function (data) {
                this.$refs.vuetable.toggleDetailRow(data.id)
            },
            formatDate: function (value, fmt) {
                if (value == null) return ''
                fmt = (typeof fmt == 'undefined') ? 'DD MMM YYYY' : fmt
                return moment(value, 'YYYY-MM-DD hh:mm:ss').format(fmt)
            },
            preg_quote: function (str) {
                return (str + '').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1");
            },
            formatMontant: function (value) {
                return value > 0 ? "<span class='text-success'>" + value + "€</span>" : "<span class='text-danger'>" + value + "€</span>";
            },
            ventilation: function (resteVentilation) {
                if (resteVentilation.SommeVentilation != null) {
                    if (resteVentilation.SommeVentilation.toFixed(2) == Math.abs(resteVentilation.montant).toFixed(2))
                        return "<span class='label label-success'>Ventilée</span>"
                    else if (resteVentilation.SommeVentilation.toFixed(2) != Math.abs(resteVentilation.montant).toFixed(2) && resteVentilation.SommeVentilation.toFixed(2) > 0)
                        return "<span class='label label-warning'>Partielle</span>"
                    else
                        return "<span class='label label-danger'>A ventiler</span> "
                }
                else
                    return "<span class='label label-danger'>A ventiler</span>"
            },
            ventilerItem: function (item) {
                this.majOperationSelected(item)
                $('#ventilationModal').modal()
            },
            dontShowIfVentille: function (item) {
                if (item.reste_ventilation.SommeVentilation != null) {
                    if (item.reste_ventilation.SommeVentilation.toFixed(2) == Math.abs(item.reste_ventilation.montant).toFixed(2))
                        return false
                    else if (item.reste_ventilation.SommeVentilation.toFixed(2) != Math.abs(item.reste_ventilation.montant).toFixed(2) && item.reste_ventilation.SommeVentilation.toFixed(2) > 0)
                        return false
                    else
                        return true
                }
                else
                    return true
            },
            setSelectedInCompteAttente: function () {
                var self = this
                this.itemProcessed = 0;
                var wrapper = document.querySelector(this.tableWrapper)
//                self.showLoadingAnimation(wrapper)
                this.$refs.vuetable.selectedTo.forEach(function (item, index, array) {
                    self.setInCompteAttente(item, true)
                })
            },
            setInCompteAttente: function (data, waitToHideLoadingAnimation = false) {
                var operation = data
                this.totalToProcess = this.$refs.vuetable.selectedTo.length

                var params = {}
                params.idOperation = operation.id
                params.idRubrique = -1
                params.montant = Math.abs(operation.montant)

                var self = this
                //GetRubrique
                this.$http.post(self.getRoute('getCompteAttente'), {entree: operation.entree}).then(function (response) {
                    params.idRubrique = response.data.rubrique.id
                    //XHR
                    this.$http.post(self.getRoute('addVentilation'), params).then(function (response) {
                        this.majOperationSelected(data)
                        self.$noty.success(response.data.message)
                        this.addVentilationFromOperationSelected(response.data.ventilation)
                        this.majOperationInSearchResults(this.operationSelected)
                        self.totalToProcess--
                        var index = _.findIndex(this.$refs.vuetable.selectedTo, {operation})
                        this.$refs.vuetable.selectedTo.splice(index, 1)
                        return true
                    }, function (response) {
                        self.$noty.error("response.data.message")
                        self.totalToProcess--
                        return false
                    })
                })
            }
        },
        computed: {
            ...mapGetters({
                getSearchRequest: 'getSearchRequest',
                getSubmitToProcess: 'getSubmitToProcess',
                getLoadingTableOperation: 'getLoadingTableOperation',
                getRoute: 'getRoute'
            })
        },
        watch: {
            perPage: function (value) {
                this.perPage = parseInt(value)
                this.$nextTick(() => this.$refs.vuetable.refresh())
            },
            getSubmitToProcess: function (value) {
                if (value) {
                    // this.$nextTick(() => {
                    this.$refs.vuetable.refresh()
                    this.submitToProcess(false)
                    // }
                    // )
                }
            },
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.routeOperationIndex = vm.getRoute("Comptabilite.operationsIndexPost");
                vm.loadRubriquesEntreesSorties();

            })
        },
        mounted: function () {

        }
    }


</script>



// WEBPACK FOOTER //
// src/components/Operations/OperationMain.vue